import api from '@/api';
export default {
    namespaced: true,
    state: () => ({
        invoices: [],
        statements: [],
        currentInvoice: null,
        isLoading: false,
        error: null,
        pagination: {
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            perPage: 200
        }
    }),
    mutations: {
        SET_INVOICES(state, invoices) {
            state.invoices = invoices;
        },
        SET_STATEMENTS(state, statements) {
            state.statements = statements;
        },
        SET_CURRENT_INVOICE(state, invoice) {
            state.currentInvoice = invoice;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
         UPDATE_INVOICE(state, updatedInvoice) {
        const index = state.invoices.findIndex(i => i.id === updatedInvoice.id);
        if (index !== -1) {
            state.invoices.splice(index, 1, updatedInvoice);
        }
    },
        SET_PAGINATION(state, pagination) {
            state.pagination = { ...state.pagination, ...pagination };
        },
        ADD_INVOICE(state, invoice) {
            state.invoices.unshift(invoice);
        },
        DELETE_INVOICE(state, invoiceId) {
            state.invoices = state.invoices.filter(i => i.id !== invoiceId);
        }
    },
    actions: {
        async fetchInvoices({ commit }, { guardianId, page = 1, perPage = 200 }) {
            try {
                commit('SET_LOADING', true);
                const response = await api.get(`/guardians/${guardianId}/wallet`, {
                    params: { page, per_page: perPage }
                });
                
                commit('SET_INVOICES', response.data.data);
                commit('SET_PAGINATION', {
                    currentPage: response.data.meta.current_page,
                    totalPages: response.data.meta.last_page,
                    totalItems: response.data.meta.total,
                    perPage: response.data.meta.per_page
                });
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        async fetchStatements({ commit }, { guardianId, page = 1, perPage = 200 }) {
            try {
                commit('SET_LOADING', true);
                const response = await api.get(`/guardians/${guardianId}/wallet/statements`, {
                    params: { page, per_page: perPage }
                });
                
                commit('SET_STATEMENTS', response.data.data);
                commit('SET_PAGINATION', {
                    currentPage: response.data.meta.current_page,
                    totalPages: response.data.meta.last_page,
                    totalItems: response.data.meta.total,
                    perPage: response.data.meta.per_page
                });
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
    async chargeWallet({ commit }, { guardianId, formData }) {
  try {
    commit('SET_LOADING', true);
    const response = await api.post(
      `/guardians/${guardianId}/wallet/charge`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' } // ✅ important
      }
    );
    commit('ADD_INVOICE', response.data.data);
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 422) {
      throw error;
    }
    commit('SET_ERROR', error.response?.data?.message || error.message);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
},

        
       async deleteInvoice({ commit }, { guardianId, invoiceId }) {
  try {
    commit('SET_LOADING', true);
    await api.delete(`/guardians/${guardianId}/wallet/invoices/${invoiceId}`);
    commit('DELETE_INVOICE', invoiceId);
    return { success: true };
  } catch (error) {
    commit('SET_ERROR', error.response?.data?.message || error.message);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
},
        
     async fetchInvoice({ commit }, { guardianId, invoiceId }) {
  try {
    commit('SET_LOADING', true);
    const response = await api.get(`/guardians/${guardianId}/wallet/invoices/${invoiceId}`);
    return response.data;
  } catch (error) {
    commit('SET_ERROR', error.response?.data?.message || error.message);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
},

async updateInvoice({ commit }, { guardianId, invoiceId, formData }) {
  try {
    commit('SET_LOADING', true);
    const response = await api.put(`/guardians/${guardianId}/wallet/invoices/${invoiceId}`, formData);
    
    // Update the invoice in state
    commit('UPDATE_INVOICE', response.data);
    
    return response.data;
  } catch (error) {
    if (error.response?.status === 422) {
      throw error;
    }
    commit('SET_ERROR', error.response?.data?.message || error.message);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
},
    },
    getters: {
        invoices: state => state.invoices,
        statements: state => state.statements,
        currentInvoice: state => state.currentInvoice,
        isLoading: state => state.isLoading,
        getError: state => state.error,
        getPagination: state => state.pagination
    }
};